<template>
  <div class="content">
    <div class="collect-wrapper">
      <!-- <search></search> -->
      <div class="header" v-for="(item,index) in list" :key="index">
        <div class="hbox" @click="openExLink(item.url)">
            <img
            class="avatar"
            width="35"
            height="35"
            :src="item.logo_url"
            >
            <div class="nickname">{{ item.appName }}</div>
        </div>
      </div>
    </div>
    <div class="chatbox"></div>
    
  </div>
</template>

<script>
import search from '@/components/search/search'
import collection from '@/components/collection/collection'
import { mapActions } from 'vuex'
import { getUserStore, deleteStore, findsAll } from '@/api'
export default {
  components: {
    collection,
    search
  },
  data () {
    return {
      list: [],
      user: {
        'nickname':'leo',
        'img':'/static/img/read.png',
        'url': 'http://baidu.com'
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    openExLink(url) {
        window.open(url, '_blank');
    },
    refreshFriend(){
      
    },
    chg(type){
      this.type = type
      this.getList()
    },
    getList () {
      findsAll({
					
		}).then(res => {
        console.log("yu获取"+res.data)
        this.list = res.data
      })
    },
  }
}
</script>

<style lang="stylus" scoped>
.content
  display flex
  width calc(100vw - 60px)
  height 100%
  .collect-wrapper
    width 260px
    height 100%
    background #fff
    box-shadow 3px 0 8px -4px rgba(0,0,0,.1)
    padding 20px
    .header  
      border-bottom 1px solid #ddd
      margin-bottom 1rem
      .hbox
        width 100%
        display flex
        height 50px
        .nickname
            font-size 1.1rem
            margin 0.5rem 0.5rem
    .item
      background gray
      color #fff
      margin-top 10px
      padding 15px 10px
      text-align center
      border-radius 5px
      cursor pointer
      font-size 14px
    .item:hover
      background #007BFF
    .active
      background #007BFF  
  .collectinfo
    // width 550px
    width calc(100vh - 310px)
    flex 1
</style>
